import request from '../utils/request';
const querystring = require('querystring')
//获取列表数据
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkCashApply/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//获取提现数据
export const getPayInfo = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkCashApply/getPayInfo.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//保存配置信息
export const saveForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkCashApply/updatePayInfo.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
}; 
export const saveForm2 = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkCashApply/updatePayInfo2.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
//提现费率
export const getConfig = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/rootConfig/get.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
}; 
//申请提现
export const addApply = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkCashApply/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
}; 


export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkOrder/deleteMemGrade.do',
        method: 'post',
        params: query
    }); 
    return list;
};
export const changeForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkMember/changeMemGrade.do',
        method: 'post',
        params: query
    }); 
    return list;
};




